import React, { useState, useRef, useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  selectFilteredMolds,
  selectMoldFilterVisible,
  selectMoldLoading,
  selectfetchMoldLoading,
} from './store/selectors';
import VirtualList from '../components/VirtualList'; // Import VirtualList
import LoadingSpinner from '../../InitialPage/Sidebar/LoadingSpinner'; // Import LoadingSpinner
import { isHeaderVisible } from 'Core/redux/main/selectors';
import { Edit, Trash2 } from 'react-feather';
import { Button, ButtonGroup } from 'react-bootstrap';
import { editMoldData } from './store/slice';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import { PartService } from '../../service/api/part-service';
import MoldReceivingPrintModal from './mold-receiving-print-modal';
import { Printer } from 'react-feather';

const MoldReceivingTile = props => {
  const [columnCount, setColumnCount] = useState(6);
  const [columnWidth, setColumnWidth] = useState(300);
  const [partsList, setPartsList] = useState([]);
  const [showPrintModal, setShowPrintModal] = useState(false);
  const [selectedToolId, setSelectedToolId] = useState(null);
  const moldTileRef = useRef(null);

  const filteredMolds = useSelector(selectFilteredMolds);
  const isLoading = useSelector(selectMoldLoading);
  const filterVisible = useSelector(selectMoldFilterVisible);
  const isFetchDataLoading = useSelector(selectfetchMoldLoading);
  const headerVisible = useSelector(isHeaderVisible);

  const updateColumnSettings = useCallback(() => {
    if (moldTileRef.current) {
      const width = moldTileRef.current.offsetWidth;
      let columns = 6;

      if (width < 576) {
        columns = 1; // Mobile
      } else if (width < 768) {
        columns = 3; // Tablets
      } else if (width < 992) {
        columns = 5; // Large screens
      } else {
        columns = 6; // Extra large screens
      }

      setColumnCount(columns);
      setColumnWidth(width / columns);
    }
  }, []);

  useEffect(() => {
    updateColumnSettings();
    window.addEventListener('resize', updateColumnSettings);
    return () => window.removeEventListener('resize', updateColumnSettings);
  }, [updateColumnSettings]);

  useEffect(() => {
    const fetchParts = async () => {
      try {
        const response = await PartService.getAllPartsList();
        if (response?.response) {
          setPartsList(response.response);
        }
      } catch (error) {
        console.error('Error fetching parts list:', error);
      }
    };

    fetchParts();
  }, []);

  const Tile = ({ mold }) => {
    const dispatch = useDispatch();
    const part = partsList.find(p => p.id === mold.partID);
    const partNumber = part?.partNumber || '';

    const handleEdit = e => {
      e.stopPropagation();
      dispatch(editMoldData(mold.toolID));
    };

    // const handleDelete = async () => {
    //   const result = await Swal.fire({
    //     title: 'Are you sure?',
    //     text: "You won't be able to revert this!",
    //     icon: 'warning',
    //     showCancelButton: true,
    //     confirmButtonColor: '#3085d6',
    //     cancelButtonColor: '#d33',
    //     confirmButtonText: 'Yes, delete it!',
    //   });

    //   if (result.isConfirmed) {
    //     dispatch(deleteMold(mold.toolID));
    //   }
    // };

    return (
      <div key={mold.toolID || Math.random()} className="tile">
        <div
          className={`card p-3 m-2 ${mold.isNewlyCreated ? 'border-success' : ''}`}
          style={{
            border: '1px solid #ddd',
            borderRadius: '4px',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
          }}
        >
          <div className="tile-actions">
            <Button variant="light" onClick={(e) => {
              e.stopPropagation();
              setSelectedToolId(mold.toolID);
              setShowPrintModal(true);
            }}>
              <Printer size={16} />
            </Button>
            <ButtonGroup size="sm" className="ms-1">
              <Button variant="light" onClick={handleEdit}>
                <Edit size={16} />
              </Button>
              {/* <Button variant="light" onClick={handleDelete}>
              <Trash2 size={16} />
            </Button> */}
            </ButtonGroup>
          </div>
          <div className="d-flex justify-content-between">
            <div className="d-flex flex-row align-items-center">
              <div className="ms-2 c-details">
                <h6 className="mb-0">{mold.toolID} </h6>
                <span>{mold.moldDescription}</span>
              </div>
            </div>
          </div>
          <div className="mt-1">
            <span
              className="badge"
              style={{
                backgroundColor: mold.backgroundColor || '#e0e0e0',
                color: mold.textColor || '#000000',
              }}
            >
              {partNumber}
            </span>
          </div>
          <div className="mt-2 tile-descriptionText text-truncate w-85">
            <h5 className="tile-description"> {mold.customerName}</h5>
          </div>
        </div>
      </div>
    );
  };

  const itemData = filteredMolds.map(mold => <Tile mold={mold} />);
  return (
    <div
      className={`tile-body ${filterVisible ? 'filter-visible' : ''} ${!headerVisible ? 'header-collapsed' : ''
        }`}
      ref={moldTileRef}
    >
      {(isLoading || isFetchDataLoading) && <LoadingSpinner />}
      {
        <VirtualList
          columnCount={columnCount}
          rowCount={Math.ceil(filteredMolds.length / columnCount)}
          itemData={itemData}
          columnWidth={columnWidth}
          rowHeight={150} // Adjusted row height
        />
      }

      <MoldReceivingPrintModal
        showModal={showPrintModal}
        onCloseModal={() => setShowPrintModal(false)}
        toolId={selectedToolId}
      />
    </div >
  );
};
const MySwal = withReactContent(Swal);

export default MoldReceivingTile;
